import { fireEvent } from 'app/shared/lib/fire-events';
import { autoinject } from 'aurelia-framework';

@autoinject
export class TriggerValidationCustomAttribute {


    constructor(private readonly element: Element) { }


    protected attached(): void {
        fireEvent(this.element, "validate", { valid: null, message: null });
    }

    protected detached(): void {
        fireEvent(this.element, "validate", { valid: null, message: null });
    }

}
